import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes,Route } from "react-router-dom";
import "./index.css";

import HomeR from "./Portfolio page/HomeR";
import About from "./Portfolio page/About";
import Education from "./Portfolio page/Education";
import Skill from "./Portfolio page/Skill";
import Projects from "./Portfolio page/Projects";
import Contact from "./Portfolio page/Contact";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
  <Routes>
    <Route path="/" element={<HomeR />}></Route>
    <Route path="/About" element={<About />}></Route>
    <Route path="/Education" element={<Education />}></Route>
    <Route path="/Skill" element={<Skill />}></Route>
    <Route path="/Projects" element={<Projects />}></Route>
    <Route path="/Contact" element={<Contact></Contact>}></Route>
  </Routes>
  </BrowserRouter>
);
